import { useState } from "react";

type PaidParameters = {
  params: any
  addPayment: (payment: any) => void;
  removePayment: (payment: any) => void;
};

const RenderPaidRow = ({ params, addPayment, removePayment }: PaidParameters) => {
  const row = params?.row ?? params
  const [paid, setPaid] = useState<boolean>(Boolean(row?.paid))

  const handlePayChange = () => {
    if (!row?.oldPaid) {
      if (paid) {
        removePayment(row?.transactionId)
        setPaid(false)
      } else {
        addPayment(row?.transactionId)
        setPaid(true)
      }
    }
  }

  return (
    <div>
      <input type='checkbox' checked={paid} onChange={handlePayChange} />
    </div>
  );
};
export { RenderPaidRow }